import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.703 32h-4.367l4.375-12H6.25c-.824 0-1.578-.405-2.069-1.11a2.87 2.87 0 0 1-.397-2.435L10.488 0H21.58l-4.375 10.667h6.502c.95 0 1.787.533 2.237 1.428s.405 1.933-.121 2.778zm-2.54-1.333h1.884L24.79 14.125c.26-.418.284-.946.053-1.4-.228-.454-.652-.725-1.136-.725h-8.412L19.67 1.333h-8.363L4.955 16.915c-.098.361-.024.817.23 1.181.254.363.641.572 1.066.572H16.54z"
    }, null, -1)
  ]))]))
}
export default { render: render }